import classes from './Header.module.scss';
import logo from '../../logo.svg';

function Header() {
    return (
        <header className={classes['header']}>
            <img src={logo} className={classes['header__logo']} alt="logo" />
            <span className={classes['header__title']}>MOVIE TRIVIA</span>
        </header>
    )
}

export default Header;
